// app/javascript/controllers/search_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "dropdown", "button"]; // Add button target
  static values = { slug: String }

  connect() {
    this.dropdownTarget.style.display = "none"; // Hide dropdown initially
    document.addEventListener("click", this.handleClickOutside.bind(this));
    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener("click", this.navigateToDestinations.bind(this)); // Add click event for button
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
    if (this.hasButtonTarget) {
      this.buttonTarget.removeEventListener("click", this.navigateToDestinations.bind(this)); // Clean up event listener
    }
  }

  isStaysPage() {
    return (this.targets.element.id === "region-search");
  }

  isHotelTypePage() {
    return (this.targets.element.id === "hotel-type-search");
  }

  search() {
    const query = this.inputTarget.value;

    if (this.hasButtonTarget) {
      // Enable or disable the button based on input value
      this.buttonTarget.disabled = query.length === 0;
    }

    if (query.length < 2) {
      this.dropdownTarget.style.display = "none"; // Hide dropdown if input is empty
      return;
    }


    const url = this.isHotelTypePage() ? "/api/v1/hotels/search_hotel_types" : "/api/v1/regions/search";
    const queryUrl = this.isStaysPage() ? `${url}?query=${encodeURIComponent(query)}&stay=${this.slugValue}` : `${url}?query=${encodeURIComponent(query)}`;

    fetch(queryUrl)
      .then(response => response.json())
      .then(data => {
        const results = this.isHotelTypePage() ? data : data.regions;
        this.updateDropdown(results);
      });
  }

  updateDropdown(data) {
    this.dropdownTarget.innerHTML = ""; // Clear previous results
    data.forEach(item => {
      const option = document.createElement("div");
      const regionName = document.createElement("span");
      regionName.className = "font-bold text-base region-name";
      regionName.textContent = item.name;

      const regionInfo = document.createElement("span");
      regionInfo.className = "text-gray-500 text-[14px] region-info";
      regionInfo.textContent = item.info_name;

      option.appendChild(regionName);
      option.appendChild(regionInfo);
      option.classList.add("dropdown-item", "flex", "flex-col", "h-16", "justify-center");
      option.addEventListener("click", () => {
        let url = this.isHotelTypePage()  ? `/${item.slug}` : `/${item.slug}/hotels`;
        if(this.isStaysPage()) {url = url + `?propertyType[]=${window.location.pathname.replace(/^\/+/, '')}`;}
        window.open(url, '_blank'); // Open in a new tab
      });
      this.dropdownTarget.appendChild(option);
    });
    this.dropdownTarget.style.display = data.length > 0 ? "block" : "none"; // Show or hide dropdown
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.style.display = "none"; // Close dropdown
    }
  }

  showDropdown() {
    this.dropdownTarget.style.display = "block"; // Show dropdown when input is focused
  }

  navigateToDestinations() {
    const query = this.inputTarget.value;
    if (query) {
      const url = new URL(window.location.href);
      url.searchParams.set('q', query);
      window.location.href = url.pathname + url.search + url.hash;
    }
  }
}